/**
 * フォームのポップアップ表示
 * @returns { void }
 */
export const formPopup = () => {
  $("#submit-popup").click(function (e) {
    $(".p-form__popup").fadeIn(200).css("display", "flex");
  });

  $(" .p-form__popup-close ").click(function (e) {
    $(".p-form__popup").fadeOut(200);
  });

  $( '.p-form__popup' ).click( function( e ) {
    if ( !$( e.target ).closest( '.p-form__popup-inner' ).length ) {
      $( '.p-form__popup' ).fadeOut( 200 );
    }
  } );
};
